import { Box, Typography } from '@mui/material';
import { DotsThreeOutline } from '@phosphor-icons/react';
import React, { useRef, useState } from 'react';
import { useAgentsSidebarContext } from './context';

interface ItemProps {
  icon: React.ReactNode;
  label: string;
  isActive?: boolean;
  isNested?: boolean;
  onClick?: () => void;
  onMenuClick?: (anchorEl: HTMLElement) => void;
}

export const Item: React.FC<ItemProps> = ({
  icon,
  label,
  isActive = false,
  isNested = false,
  onClick,
  onMenuClick,
}) => {
  const { isDarkMode, palette } = useAgentsSidebarContext();
  const [isHovered, setIsHovered] = useState(false);
  const rowRef = useRef<HTMLDivElement>(null);

  const textColor = isActive
    ? palette.blue[500]
    : isDarkMode
      ? palette.gray[300]
      : palette.gray[600];

  return (
    <Box
      ref={rowRef}
      onClick={onClick}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
      sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        padding: '4px 8px',
        cursor: 'pointer',
        borderRadius: '4px',
        backgroundColor: isActive
          ? isDarkMode
            ? palette.gray[800]
            : palette.blue[50]
          : 'transparent',
        '&:hover': {
          backgroundColor: isDarkMode ? palette.gray[800] : palette.blue[50],
        },
      }}
    >
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          gap: '8px',
          flex: 1,
          minWidth: 0,
        }}
      >
        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            flexShrink: 0,
            color: textColor,
          }}
        >
          {icon}
        </Box>
        <Typography
          sx={{
            color: textColor,
            fontFamily: 'Roboto',
            fontSize: '14px',
            fontWeight: 400,
            lineHeight: '20px',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            whiteSpace: 'nowrap',
          }}
        >
          {label}
        </Typography>
      </Box>
      {isHovered && onMenuClick && (
        <Box
          component='button'
          onClick={e => {
            e.stopPropagation();
            const row = rowRef.current;
            if (row) {
              onMenuClick(row);
            }
          }}
          sx={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            padding: 0,
            border: 'none',
            backgroundColor: 'transparent',
            cursor: 'pointer',
            color: isActive
              ? palette.blue[500]
              : isDarkMode
                ? palette.gray[400]
                : palette.gray[500],
          }}
        >
          <DotsThreeOutline size={16} weight='fill' />
        </Box>
      )}
    </Box>
  );
};
